import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/images/computerinfor_logo.png'


const _hoisted_1 = { class: "vertical-navigator" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "horizontal-menu" }
const _hoisted_4 = { class: "vertical-menu" }

import Button from "@/components/button.vue"
  import router from "@/router"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'vertical_navigator',
  props: {
    "links": {
    default: [],
    required: false,
    type: Array<{
      routeName: string,
      title: string
    }>
  },
    "linksModifiers": {},
  },
  emits: ["update:links"],
  setup(__props) {

  const links = _useModel(__props, "links")
  
  function redirect(routeName: string) {
    router.push({
      name: routeName,
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Button, {
            title: "Home",
            image: require('@/images/home_icon.png'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (redirect('index')))
          }, null, 8, ["image"]),
          _createVNode(Button, {
            title: "Customers",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (redirect('customers')))
          }),
          _createVNode(Button, {
            title: "Suppliers",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (redirect('suppliers')))
          }),
          _createVNode(Button, {
            title: "Trademarks",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (redirect('trademarks')))
          }),
          _createVNode(Button, {
            title: "Deliverables",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (redirect('deliverables')))
          }),
          _createVNode(Button, {
            title: "Purchase Orders",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (redirect('purchase_order_overview')))
          }),
          _createVNode(Button, {
            title: "Sale Orders",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (redirect('sale_order_overview')))
          }),
          _createVNode(Button, {
            title: "Finances",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (redirect('finances')))
          }),
          _createVNode(Button, {
            title: "Session",
            image: require('@/images/account_icon.png'),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (redirect('session')))
          }, null, 8, ["image"])
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "logo" }, [
          _createElementVNode("a", {
            href: "https://www.computerinfor.nl",
            target: "_blank"
          }, [
            _createElementVNode("img", {
              alt: "ComputerInfor",
              src: _imports_0
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link) => {
            return (_openBlock(), _createBlock(Button, {
              key: link.title,
              title: link.title,
              onClick: ($event: any) => (redirect(link.routeName))
            }, null, 8, ["title", "onClick"]))
          }), 128))
        ])
      ])
    ]),
    _: 3
  }))
}
}

})